<div class="toolbar-wrapper" [ngClass]="{ sticky: stickyNav, navHidden: navHidden && !mobileMenuIsOpened }"
  [class.sticky]="mobileMenuIsOpened">
  <div class="attention-block">
    <div class="container">
      <p>Við erum ekki með dekk og felgur á lager. Það tekur um 2-3 vikur að koma til landsins eftir að það hefur verið
        pantað.</p>
    </div>
    <!--
    add later : 
    Frí afhending í búðir okkar á Akureyri, Hafnarfirði og Reykjavík.
    -->
  </div>
  <p-toolbar>
    <div class="container p-toolbar-container">
      <div class="p-toolbar-group-start">
        @if(mdLayout){
        <a (click)="openGlobalSidebarMenu()">
          <button class="nav-icon-btn cart-btn-mobile" pButton pRipple>
            <div class="navigation-link-icon-wrapper">
              <img class="cart-icon" src="./../../../../assets/images/icons/navigation/menu.svg" alt="car" />
            </div>
            <span class="inner-label">
              Menu
            </span>
          </button>
        </a>
        }

        <a class="logo-link" [routerLink]="'/'+vehicleTypeService?.currentVehicleType"
          [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
          <img src="./../../../../assets/images/logos/fastparts-logo.svg" alt="fastparts-logo" />
        </a>
        <div class="d-none d-md-block pr-32-px mr-6-px"></div>
      </div>

      <div class="navigation-wrap">
        @if(!mdLayout){
        <div class="top-wrapper d-none d-lg-block">
          <app-vehicle-type-global-selection-block></app-vehicle-type-global-selection-block>
        </div>
        }

        <div class="bottom-wrapper">
          <div class="p-toolbar-group-center">


            <div class="d-none d-md-block">
              <app-add-vehicle-button-block (selectedVehicleEvent)="vehicleSelected($event)"
                [disabled]="!vehicleTypeService?.currentVehicleTypeItem?.vehicleSelection"
                [selectedVehicle]="activeVehicle"></app-add-vehicle-button-block>
            </div>
            <app-search-input [control]="searchControl" [globalSearch]="true" [name]="'global-search1'"
              [placeholder]="'Search parts'" [desktopOnly]="true"></app-search-input>



          </div>
          <div class="p-toolbar-group-end">
            <ng-container>
              <div class="nav-icons">
                <a [routerLink]="'/'+vehicleTypeService?.currentVehicleType+'/parts-catalog'"
                  [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
                  <button class="nav-icon-btn store-btn-mobile" pButton pRipple>
                    <img class="store-icon" src="./../../../../assets/images/icons/navigation/store.svg" alt="car" />
                    <span class="inner-label">Store</span>
                  </button>
                </a>


                @if(enableSavedItems){
                <a [routerLink]="'/saved-items'" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
                  <button class="nav-icon-btn star-btn-mobile" pButton pRipple>
                    <div class="navigation-link-icon-wrapper">
                      <img class="star-icon" src="./../../../../assets/images/icons/navigation/star.svg" alt="car" />
                      @if(savedItemsService.savedItemsCount$ | async; as savedItemsCount){
                      <div class="navigation-bubble red">
                        <span>{{ savedItemsCount }}</span>
                      </div>
                      }
                    </div>
                    <span class="inner-label">Saved</span>
                  </button>
                </a>
                } @if (activeCustomer$ | async; as customer) {
                <a>
                  <button (click)="lgLayout ? openUserMobileMenu() : goToUserPage()"
                    class="nav-icon-btn sign-up-btn-mobile" pButton pRipple>
                    @if(true){
                    <div class="profile-placeholder" pRipple>
                      {{
                    (customer.firstName ? customer.firstName.charAt(0) : "") +
                    (customer.lastName ? customer.lastName.charAt(0) : "")
                    }}
                    </div>
                    } @else {
                    <img class="account-icon" src="./../../../../assets/images/icons/navigation/account_circle.svg"
                      alt="car" />
                    }
                    <span class="inner-label name-tag">
                      {{ customer.firstName || "" }}
                    </span>
                  </button>
                </a>
                } @else {

                <a [routerLink]="lgLayout ? ['/auth/login'] : null" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }" (click)="!lgLayout && openLoginDialog()">
                  <button class="nav-icon-btn sign-up-btn-mobile" pButton pRipple>
                    <img class="account-icon" src="./../../../../assets/images/icons/navigation/account_circle.svg"
                      alt="car" />
                    <span class="inner-label">Sign in</span>
                  </button>
                </a>
                }

                <a (click)="openCartSidebar()">
                  <button class="nav-icon-btn cart-btn-mobile" pButton pRipple>
                    <div class="navigation-link-icon-wrapper">
                      <img class="cart-icon" src="./../../../../assets/images/icons/navigation/shopping_cart.svg"
                        alt="car" />
                      @if(activeOrder$ | async; as activeOrder){
                      <div class="navigation-bubble red">
                        <span>{{ activeOrder.totalQuantity }}</span>
                      </div>
                      }
                    </div>
                    <span class="inner-label">
                      @if(activeOrder$ | async; as activeOrder){
                      @if(activeOrder.totalWithTax | formatPrice | async; as totalPrice){
                      {{ totalPrice }}
                      } } @else { Cart }
                    </span>
                  </button>
                </a>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

    </div>
  </p-toolbar>

  <div class="mobile-toolbar">

    <div class="container">

      <app-search-input [control]="searchControl" [globalSearch]="true" [name]="'global-search2'"
        [placeholder]="'Search parts'" [mobileOnly]="true"></app-search-input>

      <!--
        [ngClass]="{ hidden: navHidden }"
        -->
      <div class="mobile-links">

        <app-mobile-add-vehicle-button-block (openAddVehicleBottomSheetEvent)="showAddVehicleBottomSheet()"
          [selectedVehicle]="activeVehicle" [disabled]="!vehicleTypeService?.currentVehicleTypeItem?.vehicleSelection">
        </app-mobile-add-vehicle-button-block>


        <a pRipple [routerLink]="'/'+vehicleTypeService?.currentVehicleType+'/parts-catalog'"
          [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }">
          <img src="./../../../../assets/images/icons/navigation/store-mobile.svg" alt="store" />
          <span class="text">STORE</span>
        </a>
      </div>
    </div>
  </div>
</div>

<p-sidebar styleClass="add-vehicle-bottom-sheet" [(visible)]="addVehicleBottomSheetOpened"
  (onHide)="closeAddVehicleBottomSheet()" position="bottom">
  <ng-template pTemplate="header">Add vehicle</ng-template>
  <ng-template pTemplate="content">
    <app-add-vehicle-form></app-add-vehicle-form>
  </ng-template>
</p-sidebar>

<p-sidebar styleClass="user-mobile-sidebar-menu" [(visible)]="userMobileMenuVisible" (onHide)="closeUserMobileMenu()"
  position="right">
  <ng-template pTemplate="header">Account</ng-template>
  <ng-template pTemplate="content">
    <app-user-inner-menu (closeUserSidenavEvent)="userMobileMenuVisible = false" [inMobileSidenav]="true">
    </app-user-inner-menu>
  </ng-template>
</p-sidebar>

<p-sidebar styleClass="cart-sidebar" [(visible)]="cartSidebarVisible" (onHide)="closeCartSidebar()" position="right">
  <ng-template pTemplate="header">Cart</ng-template>
  <ng-template pTemplate="content">
    <!--
 @if(!(activeOrder$ | async)){
      <div class="loader-wrapper">
        <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
      </div>
    } @else {

        }
    -->

    <app-sidenav-cart-inner [order]="activeOrder$ | async"></app-sidenav-cart-inner>
  </ng-template>
  <ng-template pTemplate="footer">
    <app-cart-price-and-actions-block [order]="activeOrder$ | async"></app-cart-price-and-actions-block>
  </ng-template>
</p-sidebar>



<p-sidebar styleClass="user-mobile-sidebar-menu" [(visible)]="globalSidebarMenuVisible"
  (onHide)="closeGlobalSidebarMenu()" position="left">
  <ng-template pTemplate="header">Menu</ng-template>
  <ng-template pTemplate="content">
    <div class="mt-16-unset">
      <app-vehicle-type-global-selection-list></app-vehicle-type-global-selection-list>
    </div>
  </ng-template>

</p-sidebar>
